export const THIRD_PARTY_SENSOR_LINKED_APPLIANCES_CARD_FRENCH_LOCALE = {
  title: "Appareils associés",
  toasts: {
    removeThirdPartySensorLinkedAppliances: {
      success: {
        summary: "Associations supprimées",
        detail: "Toutes les associations sélectionnées ont été supprimées avec succès.",
      },
      error: {
        summary: "Échec de la suppression",
        detail: "Aucune association n’a pu être supprimée. Merci de réessayer plus tard.",
      },
      warn: {
        summary: "Suppression partielle",
        detail: "Certaines associations n’ont pas pu être supprimées. Merci de réessayer plus tard.",
      },
    },
  },
};
